import { getYearFormat } from 'utils/formatDataHelper';
/**
 * Gets an array an check if there are the same value for the duplicates.
 * Returns on object with concat attrValue.
 * It is necessary to fix content/API issue from TecDoc.
 * @param {*} arr
 */
const concatDuplicatesArrays = (arr) => {
  return arr.reduce((prev, current) => {
    const hasDuplicates =
      current.attrValue === prev.attrValue ||
      prev.attrValue.split(', ').filter((item) => current.attrValue === item)
        .length > 0;

    if (!prev && !hasDuplicates) {
      prev = current;
    } else if (!hasDuplicates) {
      prev.attrValue = prev.attrValue + ', ' + current.attrValue;
    }

    return prev;
  });
};

/**
 * Gets an array an check if there are the same attrNames separate
 * objects in array and use only one object with concated value.
 * It is necessary to fix content/API issue from TecDoc.
 * @param {*} arr
 */
export const concatCharacteristics = (arr) => {
  return arr.reduce((prev, current) => {
    const arrFiltered = arr.filter(
      (item) => item.attrName === current.attrName
    );
    const hasDuplicates =
      prev.filter((item) => item.attrName === current.attrName).length > 0;

    // Additional operation to correct year format for some characteristics.
    // Format MM.YYYY
    if (current.attrType === 'D' && !current.attrValue.includes('.')) {
      current.attrValue = getYearFormat(current.attrValue);
    }

    if (arrFiltered.length <= 1) {
      prev.push(current);
    } else {
      if (!hasDuplicates) {
        prev.push(concatDuplicatesArrays(arrFiltered));
      }
    }

    return prev;
  }, []);
};



// WEBPACK FOOTER //
// ./src/utils/concatCharacteristics/concatCharacteristics.js